import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import './signup_discovery.scss';
import { FormattedMessage } from 'react-intl';
import { testimonies } from './signUpDiscoveryConstants';
import { MaterialIcon } from '../../../../components/material-icon/MaterialIcon';

type Props = {
  carouselLimit: number;
};
type State = {
  currentSlide: number;
  backward: boolean;
};

export class SignUpDiscoveryFromHome extends React.Component<Props, State> {
  state: State = {
    currentSlide: 0,
    backward: false,
  };

  static defaultProps = {
    carouselLimit: testimonies.length,
  };

  next = () => {
    const { carouselLimit } = this.props;
    this.setState(({ currentSlide: prevSlide }) => ({
      currentSlide: (prevSlide + 1) % carouselLimit,
    }));
  };

  previous = () => {
    const { carouselLimit } = this.props;
    this.setState(({ currentSlide: prevSlide }) => {
      const r = prevSlide - (1 % carouselLimit);
      return {
        currentSlide: r < 0 ? r + carouselLimit : r,
      };
    });
  };

  updateCurrentSlide = (index: number) => {
    const { currentSlide } = this.state;
    const { carouselLimit } = this.props;

    if (index !== currentSlide)
      this.setState(({ backward: prevBack, currentSlide: prevSlide }) => {
        let backward = prevBack;
        if (prevSlide === 0) {
          backward = false;
        }
        if (prevSlide === carouselLimit - 1) {
          backward = true;
        }

        return {
          backward,
          currentSlide: backward ? prevSlide - 1 : prevSlide + 1,
        };
      });
  };

  render() {
    return (
      <>
        <h1 className="signup-discovery__title">
          <FormattedMessage id="signup/routes/user/discovery/SignUpDiscoveryFromHome.tsx/1" />
        </h1>
        <div className="signup-discovery__subtitle">
          <FormattedMessage id="signup/routes/user/discovery/SignUpDiscoveryFromHome.tsx/2" />
          <ul className="signup-discovery__list">
            <li>
              <FormattedMessage id="signup/routes/user/discovery/SignUpDiscoveryFromHome.tsx/7" />
            </li>
            <li>
              <FormattedMessage id="signup/routes/user/discovery/SignUpDiscoveryFromHome.tsx/8" />
            </li>
            <li>
              <FormattedMessage id="signup/routes/user/discovery/SignUpDiscoveryFromHome.tsx/9" />
            </li>
            <li>
              <FormattedMessage id="signup/routes/user/discovery/SignUpDiscoveryFromHome.tsx/10" />
            </li>
          </ul>
        </div>
        <div className="signup-discovery__testimonies">
          <div className="signup-discovery__testimonies__title">
            <FormattedMessage id="signup/routes/user/discovery/SignUpDiscoveryFromHome.tsx/3" />
          </div>
          <Carousel
            selectedItem={this.state.currentSlide}
            onChange={this.updateCurrentSlide}
            showArrows={false}
            showStatus={false}
            showIndicators={false}
            showThumbs={false}
            emulateTouch
            infiniteLoop
            autoPlay
            interval={5000}
          >
            {testimonies.map(testimony => (
              <div className="signup-discovery__block" key={testimony.alt}>
                <img
                  className="signup-discovery__picture"
                  src={`/img/home/${testimony.src}`}
                  alt={testimony.alt}
                />
                <div className="signup-discovery__bubble">
                  <img
                    className="signup-discovery__quote"
                    src="/img/icons/quote.svg"
                    alt="quote"
                  />
                  <div className="signup-discovery__item">
                    <div>{testimony.text}</div>
                    <div className="signup-discovery__item__sign">
                      {testimony.name}
                      <FormattedMessage id="signup/routes/user/discovery/SignUpDiscoveryFromHome.tsx/4" />
                    </div>
                    <div className="signup-discovery__item__subsign">
                      {testimony.situation}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Carousel>
          <div className="signup-discovery__arrows">
            <button
              type="button"
              className="signup-discovery__arrow"
              onClick={this.previous}
              data-test-id="signup-discovery-previous"
            >
              <MaterialIcon
                name="navigate_before"
                className="signup-discovery__arrow__icon"
              />
              <FormattedMessage id="signup/routes/user/discovery/SignUpDiscoveryFromHome.tsx/5" />
            </button>
            <button
              type="button"
              className="signup-discovery__arrow"
              onClick={this.next}
              data-test-id="signup-discovery-next"
            >
              <FormattedMessage id="signup/routes/user/discovery/SignUpDiscoveryFromHome.tsx/6" />
              <MaterialIcon
                name="keyboard_arrow_right"
                className="signup-discovery__arrow__icon"
              />
            </button>
          </div>
        </div>
      </>
    );
  }
}
